// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.official-label-BF1CQ1{z-index:5;justify-content:center;align-items:center;display:flex;position:absolute;bottom:0;right:0;transform:translate(25%,25%)}.official-label-BF1CQ1.default-qFOcIG svg{width:20px;height:20px}.official-label-BF1CQ1.small-gGjycx svg{width:16px;height:16px}.official-label-BF1CQ1.large-XIRzQG svg{width:32px;height:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"official-label": `official-label-BF1CQ1`,
	"officialLabel": `official-label-BF1CQ1`,
	"default": `default-qFOcIG`,
	"small": `small-gGjycx`,
	"large": `large-XIRzQG`
};
export default ___CSS_LOADER_EXPORT___;
